import ClearIcon from "./ClearIcon";
import TextArea from "antd/es/input/TextArea";

interface TextAreaCellEditorProps {
  onChange?: (value?: string) => void;
  value?: string;
  prefixSymbol?: string;
  style?: React.CSSProperties;
  handleClear?: () => void;
  maxLength?: number;
  isEditable?: boolean;
}

function TextAreaCellEditor(props: TextAreaCellEditorProps) {
  const { onChange } = props;

  const defaultValue = props.value === "-" ? undefined : props.value;

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value);
  };

  // Handle clear input
  const handleClear = () => {
    onChange?.();
    props?.handleClear?.();
  };

  return (
    <TextArea
      autoSize={{ minRows: 5, maxRows: 9 }}
      onChange={handleInputChange}
      defaultValue={defaultValue}
      disabled={!props.isEditable}
      allowClear={{
        clearIcon: <ClearIcon onClick={handleClear} />,
      }}
      style={props.style}
      maxLength={props.maxLength}
      placeholder="Enter text"
    />
  );
}

export { TextAreaCellEditor };
